import { oneLineTrim } from "common-tags";
import { environment } from "../config/environment";  

const {adAuthorizeUrl : ACTIVE_DIRECTORY_AUTHORIZE_URL, adRedirectUri : DIRECTORY_REDIRECT_URI, adClientId : CLIENT_ID } = environment;

export const composeActiveDirectoryUrl = () =>
  oneLineTrim`${ACTIVE_DIRECTORY_AUTHORIZE_URL}
        ?client_id=${CLIENT_ID}
        &redirect_uri=${encodeURIComponent(DIRECTORY_REDIRECT_URI)}
        &response_type=code
        &prompt=login
        &scope=${encodeURIComponent("api://3e8523ee-603a-43c3-a95a-935ba9fcd2db/Customers.Read.All offline_access")}
        &response_mode=query
    `;

export const loginWithActiveDirectory = () => {
  const href = composeActiveDirectoryUrl();
  window.location.href = href;
};
